import { ProgressBarFlow } from 'scenes/common/types';

export const progressFromStep = <ST>(
  step: ST,
  progressFlow: ProgressBarFlow,
  stepOrder: {
    [key in ProgressBarFlow]: ST[];
  }
) => {
  const index = stepOrder[progressFlow].findIndex((p) => p === step);
  return index ? (index / stepOrder[progressFlow].length) * 100 : 0;
};
